import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {faStar} from '@fortawesome/free-solid-svg-icons/faStar'
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faKey} from '@fortawesome/free-solid-svg-icons/faKey'
import {faMobileAlt} from '@fortawesome/free-solid-svg-icons/faMobileAlt'
import {faHandshake} from '@fortawesome/free-solid-svg-icons/faHandshake'
import {faCreditCard} from '@fortawesome/free-solid-svg-icons/faCreditCard'
import {faFile} from '@fortawesome/free-solid-svg-icons/faFile'
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars'
import {faAngleDown} from '@fortawesome/free-solid-svg-icons/faAngleDown'
import {faTachometerAlt} from '@fortawesome/free-solid-svg-icons/faTachometerAlt'
import {faBell} from '@fortawesome/free-solid-svg-icons/faBell'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faChartLine} from '@fortawesome/free-solid-svg-icons/faChartLine'
import {faMoneyBill} from '@fortawesome/free-solid-svg-icons/faMoneyBill'
import {faChartPie} from '@fortawesome/free-solid-svg-icons/faChartPie'
import {faChartBar} from '@fortawesome/free-solid-svg-icons/faChartBar'
import {faWrench} from '@fortawesome/free-solid-svg-icons/faWrench'
import {faThLarge} from '@fortawesome/free-solid-svg-icons/faThLarge'
import {faColumns} from '@fortawesome/free-solid-svg-icons/faColumns'
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons/faPencilAlt'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import {faSort} from '@fortawesome/free-solid-svg-icons/faSort'
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch'
import {faQuestion} from '@fortawesome/free-solid-svg-icons/faQuestion'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faLightbulb} from '@fortawesome/free-solid-svg-icons/faLightbulb'
import {faInfo} from '@fortawesome/free-solid-svg-icons/faInfo'
import {faClipboardList} from '@fortawesome/free-solid-svg-icons/faClipboardList'
import {faEye as faEyeSolid} from '@fortawesome/free-solid-svg-icons/faEye'
import {faEye} from '@fortawesome/free-regular-svg-icons/faEye'
import {faServer} from '@fortawesome/free-solid-svg-icons/faServer'
import {faAddressCard} from '@fortawesome/free-solid-svg-icons/faAddressCard'
import {faProjectDiagram} from '@fortawesome/free-solid-svg-icons/faProjectDiagram'
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import {faCube} from '@fortawesome/free-solid-svg-icons/faCube'
import {faUpload} from '@fortawesome/free-solid-svg-icons/faUpload'
// My
import {faList} from '@fortawesome/free-solid-svg-icons/faList'
import {faHistory} from '@fortawesome/free-solid-svg-icons/faHistory'
import {faBook} from '@fortawesome/free-solid-svg-icons/faBook'
import {faUniversity} from '@fortawesome/free-solid-svg-icons/faUniversity'
import {faObjectGroup} from '@fortawesome/free-solid-svg-icons/faObjectGroup'
import {faSitemap} from '@fortawesome/free-solid-svg-icons/faSitemap'
import {faCalendarAlt} from '@fortawesome/free-regular-svg-icons/faCalendarAlt'
import {faDotCircle} from '@fortawesome/free-regular-svg-icons/faDotCircle'
import {faHome} from '@fortawesome/free-solid-svg-icons/faHome'
import {faHourglassStart} from '@fortawesome/free-solid-svg-icons/faHourglassStart'
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck'
import {faWallet} from '@fortawesome/free-solid-svg-icons/faWallet'
import {faMapSigns} from '@fortawesome/free-solid-svg-icons/faMapSigns'
import {faBolt} from '@fortawesome/free-solid-svg-icons/faBolt'
import {faArrowCircleDown} from '@fortawesome/free-solid-svg-icons/faArrowCircleDown'
import {faArrowCircleUp} from '@fortawesome/free-solid-svg-icons/faArrowCircleUp'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload'
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock'
import {faEnvelopeOpen} from '@fortawesome/free-solid-svg-icons/faEnvelopeOpen'
import {faCalendar} from '@fortawesome/free-regular-svg-icons/faCalendar'
import {faCreativeCommonsNd} from '@fortawesome/free-brands-svg-icons/faCreativeCommonsNd'
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import {faHandPointLeft} from '@fortawesome/free-regular-svg-icons/faHandPointLeft'
import {faUserGraduate} from '@fortawesome/free-solid-svg-icons/faUserGraduate'
import {faBox} from '@fortawesome/free-solid-svg-icons/faBox'
import {faUndoAlt} from '@fortawesome/free-solid-svg-icons/faUndoAlt'
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner'
import {faCircle} from '@fortawesome/free-solid-svg-icons/faCircle'
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import {faBriefcase} from '@fortawesome/free-solid-svg-icons/faBriefcase'
import {faUsers} from '@fortawesome/free-solid-svg-icons/faUsers'
import {faTasks} from '@fortawesome/free-solid-svg-icons/faTasks'
import {faClipboardCheck} from '@fortawesome/free-solid-svg-icons/faClipboardCheck'
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons/faQuestionCircle'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit'
import {faMedkit} from '@fortawesome/free-solid-svg-icons/faMedkit'
import {faGlobe} from '@fortawesome/free-solid-svg-icons/faGlobe'
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons/faSyncAlt'
import {faEdit as faEditSolid} from '@fortawesome/free-regular-svg-icons/faEdit'
import {faAmbulance} from '@fortawesome/free-solid-svg-icons/faAmbulance'
import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown'
import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp'
import {faArrowAltCircleUp} from '@fortawesome/free-regular-svg-icons/faArrowAltCircleUp'
import {faArrowAltCircleDown} from '@fortawesome/free-regular-svg-icons/faArrowAltCircleDown'
import {faFileAlt} from '@fortawesome/free-regular-svg-icons/faFileAlt'
import {faBuilding} from '@fortawesome/free-solid-svg-icons/faBuilding'
import {faIdCard} from '@fortawesome/free-solid-svg-icons/faIdCard'
import {faHandsHelping} from '@fortawesome/free-solid-svg-icons/faHandsHelping'
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import {faStopwatch} from '@fortawesome/free-solid-svg-icons/faStopwatch'
import {faIdCardAlt} from '@fortawesome/free-solid-svg-icons/faIdCardAlt'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import {faEyeSlash} from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import {faVial} from '@fortawesome/free-solid-svg-icons/faVial'
import {faLaptop} from '@fortawesome/free-solid-svg-icons/faLaptop'
import {faCoins} from '@fortawesome/free-solid-svg-icons/faCoins'
import {faCogs} from '@fortawesome/free-solid-svg-icons/faCogs'
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons/faPlusCircle'
import {faLongArrowAltDown} from '@fortawesome/free-solid-svg-icons/faLongArrowAltDown'
import {faLongArrowAltUp} from '@fortawesome/free-solid-svg-icons/faLongArrowAltUp'
import {faAngleDoubleLeft} from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft'
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import {faAngleDoubleRight} from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight'
import {faShoppingBasket} from '@fortawesome/free-solid-svg-icons/faShoppingBasket'
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog'
import {faRocket} from '@fortawesome/free-solid-svg-icons/faRocket'
import {faLock} from '@fortawesome/free-solid-svg-icons/faLock'
import {faFileArchive} from '@fortawesome/free-regular-svg-icons/faFileArchive'
import {faUserPlus} from '@fortawesome/free-solid-svg-icons/faUserPlus'
import {faComments} from '@fortawesome/free-solid-svg-icons/faComments'
import {faBullhorn} from '@fortawesome/free-solid-svg-icons/faBullhorn'
import {faTv} from '@fortawesome/free-solid-svg-icons/faTv'
import {faDatabase} from '@fortawesome/free-solid-svg-icons/faDatabase'
import {faIndustry} from '@fortawesome/free-solid-svg-icons/faIndustry'
import {faShareSquare} from '@fortawesome/free-solid-svg-icons/faShareSquare'
import {faArrowsAlt} from '@fortawesome/free-solid-svg-icons/faArrowsAlt'
import {faAlignLeft} from '@fortawesome/free-solid-svg-icons/faAlignLeft'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt'
import {faCity} from '@fortawesome/free-solid-svg-icons/faCity'
import {faUserSlash} from '@fortawesome/free-solid-svg-icons/faUserSlash'
import { sTinet } from "sooran-icon-pack/js-packages/brands/sTinet";
import { sPlus } from "sooran-icon-pack/js-packages/solid/sPlus";
import { sUpload } from "sooran-icon-pack/js-packages/solid/sUpload";
import { sTimesSquare } from "sooran-icon-pack/js-packages/solid/sTimesSquare";
import { sBook } from "sooran-icon-pack/js-packages/solid/sBook";
import { sFileEdit } from "sooran-icon-pack/js-packages/solid/sFileEdit";




library.add(
    faKey, faUser, faMobileAlt, faHandshake, faCreditCard, faFile, faBars, faAngleDown, faTachometerAlt, faBell, faDownload, faClock, faEnvelopeOpen, faArrowAltCircleDown, faArrowAltCircleUp,
    faEnvelope, faChartLine, faMoneyBill, faChartBar, faChartPie, faWrench, faThLarge, faColumns, faArrowCircleDown, faArrowCircleUp, faSortDown, faSortUp, faBuilding, faIdCard,
    faList, faHistory, faBook, faUniversity, faObjectGroup, faSitemap, faTrash, faCalendarAlt, faDotCircle, faHome, faHourglassStart, faCheck, faWallet, faUpload, faSpinner, faCircle, faTimesCircle,
    faBriefcase, faUsers, faTasks, faClipboardCheck, faQuestionCircle, faStar, faPhone, faEdit, faSyncAlt,faGlobe,faAngleDoubleLeft, faAngleRight, faEditSolid, faAmbulance, 
    faPencilAlt, faTimes, faInfoCircle, faSort, faSearch, faQuestion, faPlus, faLightbulb, faInfo, faEye, faCheckCircle, faComments, faCalendar, faAngleLeft, faAngleDoubleRight,
    faClipboardList, faServer, faAddressCard, faProjectDiagram, faShoppingCart, faCube, faMapSigns, faBolt, faHandsHelping,faLongArrowAltUp, faLongArrowAltDown, faShoppingBasket, faCog, faRocket, faLock,
    faCreativeCommonsNd, faBox, faSignOutAlt, faHandPointLeft, faUserGraduate, faUndoAlt, faArrowLeft, faGlobe,faLock, faFileArchive, faUserPlus, faUserPlus, 
    faList, faHistory, faBook, faUniversity, faSitemap, faDotCircle, faHome, faHourglassStart, faCheck,faLongArrowAltUp, faLongArrowAltDown, faShoppingBasket, faCog, faRocket,
    faStopwatch, faIdCardAlt, faExclamationTriangle, faExclamationCircle, faEyeSlash, faVial, faLaptop, faFileAlt, faCoins, faCogs, faPlusCircle, faLongArrowAltDown, 
    faBullhorn,faArrowsAlt,faAlignLeft,faExternalLinkAlt,faShareSquare, faIndustry,faDatabase, faTv,faCity,faMedkit,faUserSlash,faEyeSolid,

        // Sooran Icon
        sTinet,sPlus,sTimesSquare,sUpload,sBook,sFileEdit

)

dom.watch()